<form [formGroup]="form" class="forms" (ngSubmit)="onClickAdd()">
  <div class="header">
    <h1 class="title">{{ config.title }}</h1>
  </div>

  <div class="form-container">
    <div class="form-group">
      <div class="inputs" *ngIf="config.type === 'email'">
        <label [for]="config.formControlName"> {{ config.label }} </label>
        <input
          class="form-control"
          type="email"
          placeholder="email@exemplo.com.br"
          maxlength="60"
          [email]="true"
          appEmailValidator
          appShowErrorMessages
          [required]="false"
          [formControlName]="config.formControlName"
          [name]="config.formControlName"
        />
      </div>
    </div>
  </div>

  <div class="button-row">
    <button type="button" (click)="onClose()" class="bt-back btn btn-border-orange">
      Fechar
    </button>

    <button
      type="submit"
      
      class="bt-go btn btn-full-orange"
      [ngClass]="{ disabled: form.invalid }"
    >
      {{ config.okBtnLabel }}
    </button>
  </div>
</form>
